import { memo } from "react";
import { useNavigate } from "react-router";
import { Navbar as NextUINavbar, NavbarItem, Button } from "@heroui/react";
import { ArrowLeftIcon } from "@phosphor-icons/react";
import clsx from "clsx";

import { ICON_SIZE } from "@/config/constants";
import { Menu, MenuItem } from "./Menu";
import { Logo } from "../common/Logo";
import { useBoundStore } from "@/app/store";

export interface NavbarProps {
  actions?: React.ReactNode[];
  classNames?: {
    wrapper?: string;
  };
  hideBack?: boolean;
  hideLogo?: boolean;
  input?: React.ReactNode;
  menuItems?: MenuItem[];
  title?: string;
  onBack?: () => void;
}

function NavbarComponent() {
  const navigate = useNavigate();
  const navbar = useBoundStore((state) => state.pageLayout.navbar);

  if (!navbar) {
    return null;
  }

  const { actions = [], classNames, hideBack = false, hideLogo = true, input, menuItems = [], title, onBack } = navbar;

  return (
    <NextUINavbar
      classNames={{ wrapper: clsx("gap-2 px-4", classNames?.wrapper) }}
      style={{ top: "var(--inset-top)" }}
      position="sticky"
    >
      <div className="mr-2 flex items-center gap-2">
        {!hideBack && (
          <Button isIconOnly size="sm" variant="light" onPress={onBack ? onBack : () => navigate(-1)}>
            <ArrowLeftIcon size={ICON_SIZE.md} weight="bold" />
          </Button>
        )}

        {!hideLogo || title ? (
          <div className="flex">
            {hideLogo ? null : <Logo size={28} />}
            {title ? <span className="line-clamp-1 text-xl font-semibold">{title}</span> : null}
          </div>
        ) : null}
      </div>

      <div className="flex grow items-center justify-end gap-1">
        {input ? <div className="flex w-full max-w-sm min-w-0 items-center justify-end">{input}</div> : null}
        {actions.map((action, index) => (
          <NavbarItem key={index}>{action}</NavbarItem>
        ))}
        {menuItems.length ? (
          <NavbarItem>
            <Menu items={menuItems} />
          </NavbarItem>
        ) : null}
      </div>
    </NextUINavbar>
  );
}

export const NavbarMobile = memo(NavbarComponent);
